import { z } from "zod";
export const CATEGORIAS_GASTO_PERSONAL = [
    "Alimentación",
    "Transporte & Gasolina",
    "Vivienda & Servicios",
    "Salud & Medicamentos",
    "Ropa & Calzado",
    "Entretenimiento & Ocio",
    "Educación & Cursos",
    "Supermercado & Compras",
    "Deudas & Bancos",
    "Hogar & Mantenimiento",
    "Otros Gastos",
];
export const METODOS_PAGO_GASTO_PERSONAL = [
    "EFECTIVO",
    "NEQUI",
    "DAVIPLATA",
    "BANCOLOMBIA",
    "TARJETA_DEBITO",
    "TARJETA_CREDITO",
    "TRANSFERENCIA",
    "OTRO",
];
export const GastoPersonalSchema = z.object({
    id: z.string(),
    usuarioId: z.string(),
    sucursalId: z.string(),
    monto: z.number(),
    concepto: z.string(),
    categoria: z.string(),
    establecimiento: z.string().nullable().optional(),
    metodoPago: z.string(),
    fecha: z.string(),
    notas: z.string().nullable().optional(),
    comprobanteUrl: z.string().nullable().optional(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
    usuarioNombre: z.string().optional(),
});
export const CrearGastoPersonalSchema = z.object({
    monto: z.number().positive("El monto debe ser un valor mayor a cero"),
    concepto: z.string().min(2, "El concepto debe tener al menos 2 caracteres").max(191),
    categoria: z.string().min(1, "La categoría es requerida").max(100),
    establecimiento: z.string().max(191).optional().nullable(),
    metodoPago: z.string().min(1, "El método de pago es requerido").max(50),
    fecha: z.string().optional().nullable(),
    notas: z.string().max(1000).optional().nullable(),
    comprobanteUrl: z.string().max(500).optional().nullable(),
});
export const ActualizarGastoPersonalSchema = CrearGastoPersonalSchema.partial();
export const FiltroGastosPersonalesSchema = z.object({
    mes: z.coerce.number().min(1).max(12).optional(),
    anio: z.coerce.number().min(2020).max(2100).optional(),
    desde: z.string().optional(),
    hasta: z.string().optional(),
    categoria: z.string().optional(),
    metodoPago: z.string().optional(),
    busqueda: z.string().optional(),
});
export const DesgloseCategoriaSchema = z.object({
    categoria: z.string(),
    total: z.number(),
    cantidad: z.number(),
    porcentaje: z.number(),
});
export const DesgloseMetodoPagoSchema = z.object({
    metodoPago: z.string(),
    total: z.number(),
    cantidad: z.number(),
});
export const ResumenGastosPersonalesSchema = z.object({
    totalGastado: z.number(),
    cantidadGastos: z.number(),
    promedioGasto: z.number(),
    categoriaTop: z
        .object({
        categoria: z.string(),
        total: z.number(),
    })
        .nullable(),
    desgloseCategorias: z.array(DesgloseCategoriaSchema),
    desgloseMetodosPago: z.array(DesgloseMetodoPagoSchema),
});
export const ListaGastosPersonalesRespuestaSchema = z.object({
    gastos: z.array(GastoPersonalSchema),
    resumen: ResumenGastosPersonalesSchema,
});
//# sourceMappingURL=gastos-personales.schema.js.map